var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraAni20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 563 733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d5d6d5;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-6, .cls-7, .cls-8, .cls-9, .cls-11 {\n        stroke: #2d312d;\n      }\n\n      .cls-2 {\n        fill: #007f21;\n      }\n\n      .cls-3 {\n        fill: #cb3c00;\n      }\n\n      .cls-3, .cls-5, .cls-10, .cls-12 {\n        stroke: #000;\n      }\n\n      .cls-4 {\n        fill: #818381;\n      }\n\n      .cls-5 {\n        stroke-width: 2px;\n      }\n\n      .cls-5, .cls-12 {\n        fill: #f1eadd;\n      }\n\n      .cls-6, .cls-10 {\n        fill: #575a57;\n      }\n\n      .cls-7 {\n        fill: #abadab;\n      }\n\n      .cls-13 {\n        fill: #2d312d;\n      }\n\n      .cls-8 {\n        fill: #d00038;\n      }\n\n      .cls-9 {\n        fill: #e9bba4;\n      }\n\n      .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        opacity: 0;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1,
    y: 1,
    width: 561,
    height: 731,
    rx: 22.95,
    ry: 22.95
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "290.86 322.96 138.75 689.44 152.67 689.44 299.25 325.44 290.86 322.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 299.75,
    y: 325.44,
    width: 12,
    height: 364
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 282.75,
    y: 297.44,
    width: 46,
    height: 31,
    rx: 15.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 267.75,
    y: 261.44,
    width: 76,
    height: 48,
    rx: 14.47,
    ry: 14.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "359.25 247.77 381.04 232.53 478.22 232.53 478.22 240.15 381.49 240.15 348.79 266.93 359.25 247.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M243.71,235.44s10.89,52.11,62.47,51.7c0,0,53.56,0,55.07-51.7h-117.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 236.75,
    y: 212.44,
    width: 134,
    height: 23,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 267.75,
    y: 293.44,
    width: 76,
    height: 20,
    rx: 6.36,
    ry: 6.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M78.49,102.1c-.25,40.08-.51,80.17-.76,120.25,14.09-2,27.81-6.54,40.32-13.33,4.94-2.69,9.95-5.99,12.33-11.09,1.87-3.99,1.89-8.56,1.87-12.97-.07-18.35-.14-36.71-.2-55.06,0-1.48-.03-3.04-.78-4.32-.63-1.08-1.7-1.82-2.73-2.53-4.32-2.96-8.65-5.91-12.99-8.85-9.91-6.73-20.71-13.69-32.68-13.35-2.09.06-4.88,1.4-4.38,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.42,197.55c2.71,3.66,9.38,4.25,11.37.16.72-1.49.69-3.21.65-4.86-.6-21.9-1.2-43.81-1.8-65.71-.02-.81-.07-1.69-.61-2.29-.52-.59-1.37-.75-2.14-.87-2.22-.36-5.04-.44-6.11,1.54-.41.76-.44,1.67-.46,2.54-.43,22.37-.86,44.73-1.29,67.1-.02,1.09.31,2.56.39,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.65,126.68c2.76-.91,5.88-.64,8.45.73.11,23.02.96,46.03,2.55,68.99-2.86-1.41-7.02,1.1-9.18-1.25-.86-.94-.99-2.32-1.06-3.59-1.31-21.68-1.72-43.4-.76-64.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M360.92,99.12c2.17-4.25,4.73-8.86,9.2-10.52,2.06-.76,4.3-.8,6.49-.83,10.68-.11,21.36-.06,32.04.17,1.55,10.85,1.99,21.85,1.3,32.79-.07,1.06-.18,2.21-.93,2.96-.78.8-2.01.9-3.13.95-11.34.53-22.69,1.07-34.03,1.6-1.01.05-2.08.08-2.96-.43-.79-.46-1.28-1.29-1.71-2.09-3.79-6.98-6-14.8-6.41-22.73-.07-1.27.04-2.79.13-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151.06,127.79l.3-5.26c6.7.06,13.41.13,20.11.19,1.78.02,3.86.19,4.84,1.67.57.86.61,1.96.63,3,.42,24.34-.03,48.69-1.35,73-6.06.84-12.23.94-18.32.31-1.6-.17-3.43-.54-4.19-1.95-.38-.7-.41-1.54-.43-2.34-.54-19.9-1.09-39.8-1.63-59.7-.13-4.61-.25-9.24.04-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.27,106.85c1.99-10.89,2.58-22.03,1.76-33.08-.34-4.55-.85-9.42,1.36-13.42,3.71-6.73,12.87-7.6,20.56-7.65,16.81-.1,33.61-.21,50.42-.24.53.07,1.05.14,1.78.29,5.78-1.23,11.3,2.63,15.96,6.27,5.48,4.28,10.96,8.56,16.43,12.84,4.57,3.57,9.32,7.37,11.66,12.68,2.34,5.31,1.32,12.59-3.75,15.42-1.46.81-3.12,1.2-4.75,1.56-13.41,3.04-26.93,5.94-40.65,6.82-10.13.65-20.3.18-30.45-.28-13.5-.62-27.01-1.23-40.34-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.63,117.23c2.24-4.36,4.94-9.1,9.61-10.56,1.9-.59,3.92-.56,5.91-.52,2.84.05,5.67.1,8.51.16,1.07.02,2.46.31,2.58,1.37.06.48-.21.94-.47,1.36-1.42,2.26-3.08,4.37-4.32,6.73-5.11,9.69-2.61,21.95-7.28,31.86-.6,1.28-1.46,2.62-2.83,2.98-1.34.35-2.77-.39-3.63-1.47s-1.27-2.44-1.65-3.77c-2.6-9.07-4.7-18.28-6.29-27.59-.13-.79-.18-1.78-.14-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M261.31,101.05c-4.87-2.05-8.03-7-9.29-12.13s-.9-10.5-.53-15.77c.14-2.05.36-4.28,1.77-5.77,1.62-1.71,4.24-1.87,6.59-1.92,18.6-.4,37.19-.8,55.79-1.2,2.07-.04,4.16-.09,6.18.37,3.86.88,7.05,3.5,10.09,6.03,4.09,3.41,8.18,6.83,12.27,10.24,3.37,2.81,7.05,6.27,6.88,10.66-.12,3.26-2.49,6.11-5.35,7.69s-6.16,2.12-9.39,2.57c-24.45,3.43-49.37,3.52-73.85.27-.74-.1-1.72-.58-1.18-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.03,106.13c0-3.39,2.69-6.31,5.8-7.64s6.6-1.4,9.99-1.45c5.42-.08,10.84-.16,16.26-.23,23.29-.33,46.57-.67,69.86-1,2.11-.03,4.41,0,6.06,1.33,2.11,1.7,2.29,4.8,2.3,7.51.07,32.95.14,65.89.21,98.84,0,1.92,0,3.91-.75,5.68-2.08,4.91-8.48,5.92-13.8,6.18-28.9,1.44-57.84,2.04-86.78,1.8-4.9-.04-10.2-.25-14-3.34-4.01-3.27-5.19-8.81-6-13.92-1.98-12.48-3.28-25.06-3.89-37.68-.47-9.56-.54-19.13-.24-28.69.19-6.08.59-12.39,3.5-17.73,3.08-5.65,8.57-9.51,11.5-9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.64,170.16c-2.79,10.82-5.15,21.74-7.07,32.75-.2,1.17-.4,2.39-.09,3.54.32,1.2,1.16,2.19,1.98,3.13,1.12,1.3,2.24,2.6,3.37,3.89,1.01,1.16,2.07,2.37,3.49,2.96,1.28.53,2.71.5,4.09.46,3-.08,6.01-.17,9.01-.25,1.73-.05,3.88-.41,4.36-2.06.29-.98-.18-2.01-.63-2.93-5.72-11.87-9.24-24.8-10.32-37.94-.15-1.82-.27-3.7-1.13-5.31s-2.71-2.85-4.48-2.38c-2.52.67-3.08,3.93-2.57,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.92,122.06c.69,21.69.29,43.42-1.2,65.07-.24,3.52-.51,7.11.3,10.55s2.9,6.77,6.15,8.16c2.14.92,4.55.91,6.88.89,6.92-.06,13.84-.12,20.75-.18,5.08-.04,10.44-.17,14.76-2.84,4.14-2.56,6.69-7.16,7.81-11.89,1.13-4.73,1-9.67.86-14.53-.41-14.76-.82-29.52-1.23-44.28-.17-6-1.23-13.33-6.84-15.47-1.81-.69-3.8-.67-5.73-.64-10.47.17-20.94.34-31.42.51-2.66.04-5.43.11-7.78,1.35s-4.12,4.03-3.33,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.15,111.3c-3.92,33.5-3.31,67.52,1.8,100.86.2,1.29.47,2.7,1.5,3.51.96.76,2.3.75,3.52.71,4.01-.13,8.02-.26,12.02-.39-.8-3.23-4.34-4.86-6.39-7.47-2.09-2.66-2.55-6.21-2.92-9.57-2.65-23.54-5.29-47.31-2.84-70.87.47-4.5,1.21-9.19,3.92-12.8,2.52-3.36,6.64-5.64,7.97-9.62-3.27.28-6.54.57-9.81.85-2.48.22-5.1.48-7.14,1.9s-3.2,4.45-1.63,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.63,147.99c-.23,5.51-.22,11.03.02,16.55.04.86.11,1.79.66,2.45.64.77,1.73.95,2.73,1.05,2.27.22,4.56.25,6.84.09.6-.04,1.24-.11,1.72-.48.69-.53.83-1.51.9-2.38.41-5.15.43-10.33.08-15.49-.06-.84-.15-1.75-.74-2.36-.68-.71-1.78-.77-2.76-.79-2.06-.03-4.12-.05-6.17-.08-.93-.01-1.91,0-2.69.49s-1.18,1.69-.58.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M282.58,123.71c-7.02,5.57-1.77,17.8-6.71,25.27-2.43,3.67-6.94,5.52-9.47,9.11-2.63,3.74-2.68,8.66-2.42,13.23.28,5.03.8,10.04,1.56,15.02.21,1.37.47,2.8,1.34,3.88,1.45,1.8,4.06,2.02,6.37,2.09,23.66.75,47.35.71,71.01-.09,3.37-.11,7.13-.42,9.37-2.94,2.11-2.36,2.14-5.86,2.06-9.03-.44-16.71-.87-33.41-1.31-50.12-.06-2.42-.29-5.17-2.19-6.66-1.49-1.17-3.55-1.17-5.44-1.12-21.64.55-43.28,1.3-64.16,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.16,133.12c-.58,16.11-.17,32.26,1.24,48.32.06.7.14,1.44.59,1.98.58.7,1.58.84,2.48.91,1.73.13,3.47.18,5.2.16.65-.01,1.37-.06,1.84-.5.37-.35.52-.87.64-1.37.7-3.05.7-6.21.7-9.35,0-10.68,0-21.35.01-32.03,0-3.92-.31-8.48-3.51-10.74-3.28-2.31-9.08-.3-9.19,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.87,137.03c-1.54.4-3.16,1.2-3.7,2.69-.64,1.77.84,3.91,2.72,4.04s3.61-1.65,3.54-3.53-1.78-3.4-2.56-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.19,152.41c-1.67.3-3.18,1.5-3.69,3.11s.1,3.56,1.53,4.46c2.15,1.36,5.41-.36,5.71-2.89s-2.18-4.94-3.54-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.2,170.39c-2.03.62-3.6,2.69-3.4,4.8s2.37,3.9,4.45,3.47c2.07-.43,3.35-2.87,2.84-4.93s-2.53-3.76-3.89-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.82,116.53c-1.58.89-3.24,1.86-4.12,3.45-.6,1.09-.76,2.36-.9,3.6-.85,8.05-.74,16.2.32,24.23.09.68.21,1.4.66,1.9.98,1.08,2.74.53,4.06-.09,3.67-1.74,7.58-3.69,9.48-7.27,1.04-1.96,1.37-4.22,1.59-6.43.4-4.11.49-8.25.27-12.37-.07-1.22-.17-2.47-.7-3.57-.88-1.82-2.81-2.94-4.79-3.34s-4.26-1.02-5.88-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.04,141.67l-.51,25.32c-.02,1.17-.02,2.43.68,3.37.91,1.24,2.65,1.45,4.18,1.56,12.88.92,25.92,1.84,38.61-.5.8-.15,1.66-.35,2.16-.99.43-.55.48-1.29.51-1.99.42-8.99.48-18,.17-27-.02-.61-.07-1.28-.48-1.74-.46-.51-1.23-.58-1.92-.61-12.91-.61-25.84-.69-38.75-.22-1.26.05-2.58.12-3.65.79s-1.72,2.17-1,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.86,147.52c-.44,4.38-.57,8.79-.39,13.19.02.61.08,1.28.53,1.69.38.36.94.43,1.46.47,6.87.61,13.79.6,20.66-.02.81-.07,1.72-.21,2.2-.86.3-.4.37-.91.43-1.4.52-4.05.63-8.15.34-12.22-.04-.62-.12-1.29-.54-1.75-.52-.56-1.39-.6-2.15-.61-6.53-.02-13.06-.04-19.59-.06-.78,0-1.6,0-2.3.35s-1.24,1.16-.65,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.72,124.6c-1.3.14-2.36,1.21-2.85,2.43s-.51,2.57-.48,3.88c.05,3.21.32,6.41.79,9.58,1.99-.06,3.74-1.49,4.73-3.22s1.36-3.74,1.72-5.7c.32-1.76.63-3.66-.14-5.27s-3.09-2.59-3.77-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M411.58,82.58c-3.42,2.17-3.62,7-3.44,11.05.36,7.92.71,15.84,1.07,23.76.08,1.75.16,3.53.73,5.2,1.29,3.81,5.27,6.52,9.29,6.33,1.91-.09,4.05-1.09,4.4-2.97.44-2.39-2.13-4.09-3.57-6.05-1.67-2.26-1.89-5.25-2.05-8.06-.3-5.14-.59-10.29-.89-15.43-.14-2.35-.23-4.88,1.03-6.87.74-1.17,1.88-2.03,2.74-3.12s1.41-2.63.75-3.85c-.55-1.01-1.75-1.47-2.88-1.64-2.98-.46-5.94.88-7.17,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.79,46.87c-2.53,1.94-2.73,5.61-2.71,8.8.06,8.87.12,17.73.19,26.6,0,.49.04,1.04.41,1.36.3.25.72.27,1.11.28,6.46.11,12.92.22,19.38.33,4.64.08,9.37.15,13.82-1.17,4.45-1.31,8.67-4.25,10.36-8.57,1.05-2.68,1.05-5.63,1.04-8.5,0-2.89-.02-5.78-.03-8.67,0-.74,0-1.49-.18-2.21-.25-1.07-.86-2.02-1.55-2.86-4.89-5.96-13.57-6.83-21.28-6.76-7.21.07-14.42.58-20.56,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.76,54.97c-.97,6.93-1.16,13.97-.57,20.95.05.58.13,1.21.55,1.61.35.33.86.42,1.34.49,1.3.17,2.61.24,3.92.21.75-.02,1.55-.08,2.16-.53.88-.64,1.09-1.85,1.23-2.93.77-6.03,1.54-12.15.65-18.16-.12-.82-.33-1.73-1.02-2.2-.56-.39-1.29-.38-1.97-.35-1.99.07-3.97.14-5.96.21-.19.45-.38.91-.34.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M236.13,61.84c-1.96.51-3.73,2.04-4.12,4.03s.95,4.27,2.95,4.56c2.12.31,4.11-1.73,4.16-3.87s-1.46-4.1-3-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.19,53.51c-10.67-.98-21.45-.89-32.1.27-.48.05-.98.11-1.36.4-.5.37-.69,1.01-.84,1.61-1.51,6.27-1.05,12.82-.59,19.25.11,1.56.36,3.36,1.7,4.17.76.46,1.7.48,2.59.49,9.38.06,18.76.08,28.14.05.4,0,.82,0,1.15-.23.54-.36.62-1.11.65-1.76.29-7.28.59-14.56.88-21.84.03-.85.02-1.82-.22-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195.36,59.83c11.78-.11,23.57.04,35.35.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195.59,66.32c11.78-.24,23.57-.32,35.35-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M196.26,72.95c11.11.4,22.21.8,33.32,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.43,53.4c-1.06,8.82-.94,17.77.38,26.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M210.46,53.18c-.16,8.94-.5,17.87-1.02,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.96,48.93c-3.6.06-7.21.11-10.81.17-.3,0-.61.01-.87.15-.58.31-.67,1.1-.68,1.77-.15,9.41-.3,18.81-.45,28.22-.01.92,0,1.91.53,2.66.75,1.05,2.21,1.22,3.5,1.3,1.91.12,3.82.23,5.74.35.49.03,1,.06,1.47-.1,1.51-.5,1.83-2.45,1.89-4.04.3-8.27.61-16.53.91-24.8.07-1.88.09-3.93-1.22-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M216.37,52.74c-1.23,8.94-1.62,18-1.16,27.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M223.02,52.96c-.5,8.85-.63,17.71-.4,26.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M236.85,63.27c-1.22-1.11-3.34-.75-4.4.52s-1.15,3.14-.57,4.69c.78,2.09,3.33,3.77,5.25,2.62.93-.55,1.44-1.61,1.72-2.65.33-1.22.39-2.56-.14-3.7s-1.79-2-1.86-1.48Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "285.78 318.74 114.9 676.85 128.79 677.57 294.03 321.65 285.78 318.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "283.67 227.82 416.59 601.68 402.69 600.96 275.15 229.85 283.67 227.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 285.1,
    y: 321.74,
    width: 12,
    height: 364,
    transform: "translate(26.48 -14.4) rotate(2.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 278.17,
    y: 294,
    width: 46,
    height: 31,
    rx: 15.5,
    ry: 15.5,
    transform: "translate(16.43 -15.18) rotate(2.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 264.6,
    y: 258.04,
    width: 76,
    height: 48,
    rx: 14.47,
    ry: 14.47,
    transform: "translate(15.01 -15.29) rotate(2.97)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "357.97 247.19 380.52 233.1 477.57 238.13 477.17 245.74 380.58 240.73 346.54 265.79 357.97 247.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M243.23,228.89s8.18,52.6,59.7,54.87c0,0,53.49,2.78,57.67-48.78l-117.38-6.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 236.78,
    y: 209.02,
    width: 134,
    height: 23,
    rx: 8.9,
    ry: 8.9,
    transform: "translate(11.83 -15.44) rotate(2.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 473.9,
    y: 235.02,
    width: 45,
    height: 15,
    rx: 6.12,
    ry: 6.12,
    transform: "translate(13.23 -25.38) rotate(2.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 263.66,
    y: 290.02,
    width: 76,
    height: 20,
    rx: 6.36,
    ry: 6.36,
    transform: "translate(15.94 -15.22) rotate(2.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M85.14,87.17c-2.33,40.02-4.66,80.03-6.99,120.05,14.17-1.27,28.11-5.09,40.95-11.23,5.08-2.43,10.24-5.47,12.89-10.43,2.07-3.89,2.33-8.45,2.54-12.85.88-18.33,1.76-36.67,2.65-55,.07-1.48.13-3.04-.55-4.35-.57-1.11-1.6-1.91-2.59-2.67-4.17-3.18-8.34-6.35-12.51-9.51-9.54-7.23-19.98-14.74-31.95-15.02-2.09-.05-4.95,1.14-4.44,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.05,185.25c2.52,3.79,9.15,4.73,11.35.75.8-1.45.86-3.17.9-4.82.54-21.91,1.07-43.81,1.61-65.72.02-.81.02-1.69-.49-2.32-.49-.61-1.33-.82-2.1-.98-2.2-.47-5.01-.7-6.18,1.22-.45.74-.52,1.64-.59,2.51-1.59,22.31-3.18,44.63-4.77,66.94-.08,1.08.18,2.57.27,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.94,115.04c2.8-.76,5.91-.33,8.4,1.16-1.08,22.99-1.43,46.01-1.03,69.03-2.78-1.55-7.07.73-9.1-1.72-.81-.98-.87-2.37-.88-3.64-.19-21.71.53-43.44,2.61-64.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.34,98.83c2.39-4.14,5.18-8.61,9.74-10.03,2.09-.66,4.33-.58,6.53-.49,10.67.44,21.34,1.05,31.99,1.83.99,10.91.85,21.93-.4,32.81-.12,1.05-.3,2.19-1.08,2.91-.82.75-2.06.79-3.17.79-11.36-.05-22.71-.11-34.07-.16-1.01,0-2.09-.03-2.93-.58-.76-.5-1.21-1.35-1.6-2.18-3.42-7.16-5.22-15.09-5.23-23.03,0-1.27.18-2.78.22-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M156.27,116.59l.57-5.24c6.69.41,13.38.82,20.07,1.24,1.78.11,3.84.38,4.75,1.92.53.89.51,1.99.47,3.03-.84,24.33-2.55,48.63-5.13,72.83-6.1.52-12.26.3-18.31-.64-1.59-.25-3.39-.71-4.08-2.16-.34-.72-.33-1.56-.31-2.36.49-19.9.98-39.8,1.46-59.71.11-4.61.23-9.24.5-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.45,100.35c2.55-10.77,3.72-21.87,3.48-32.94-.1-4.56-.36-9.46,2.05-13.33,4.06-6.53,13.24-6.93,20.93-6.58,16.79.77,33.58,1.53,50.37,2.37.52.1,1.04.2,1.76.38,5.84-.93,11.15,3.21,15.62,7.09,5.25,4.56,10.5,9.12,15.75,13.68,4.38,3.81,8.93,7.84,10.99,13.27,2.06,5.43.67,12.64-4.54,15.2-1.5.74-3.17,1.03-4.82,1.32-13.55,2.34-27.2,4.54-40.95,4.7-10.15.12-20.29-.87-30.39-1.86-13.45-1.31-26.91-2.63-40.23-3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.3,109.81c2.46-4.23,5.4-8.83,10.15-10.05,1.92-.49,3.94-.36,5.93-.22,2.83.2,5.66.4,8.49.6,1.07.08,2.44.44,2.51,1.51.03.49-.26.93-.54,1.33-1.54,2.18-3.3,4.21-4.67,6.5-5.61,9.41-3.74,21.78-8.92,31.44-.67,1.25-1.6,2.54-2.98,2.83-1.35.28-2.74-.54-3.55-1.66s-1.14-2.5-1.46-3.85c-2.13-9.19-3.75-18.5-4.85-27.88-.09-.8-.09-1.79-.11-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M267.76,95.6c-4.75-2.3-7.66-7.41-8.65-12.6s-.36-10.54.28-15.78c.25-2.04.58-4.25,2.07-5.67,1.71-1.62,4.33-1.65,6.68-1.58,18.59.56,37.19,1.12,55.78,1.69,2.07.06,4.16.13,6.15.69,3.81,1.08,6.86,3.86,9.77,6.55,3.91,3.62,7.82,7.24,11.73,10.86,3.22,2.98,6.71,6.63,6.32,11-.29,3.25-2.8,5.97-5.74,7.4s-6.26,1.79-9.51,2.08c-24.6,2.15-49.49.95-73.76-3.55-.73-.14-1.69-.67-1.13-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.22,100.65c.17-3.38,3.01-6.16,6.19-7.33s6.67-1.06,10.05-.93c5.42.2,10.83.41,16.25.61,23.27.87,46.54,1.75,69.82,2.62,2.11.08,4.41.23,5.98,1.64,2.02,1.81,2.04,4.91,1.91,7.62-1.64,32.9-3.28,65.81-4.91,98.71-.1,1.92-.21,3.91-1.05,5.64-2.33,4.8-8.77,5.47-14.11,5.46-28.94-.06-57.87-.96-86.76-2.7-4.89-.29-10.18-.78-13.81-4.06-3.84-3.47-4.73-9.07-5.27-14.21-1.33-12.56-1.98-25.2-1.94-37.83.03-9.57.45-19.13,1.25-28.67.5-6.06,1.23-12.34,4.41-17.52,3.37-5.48,9.05-9.05,11.99-9.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.55,163.14c-3.34,10.66-6.26,21.45-8.75,32.34-.26,1.16-.53,2.36-.28,3.53.26,1.22,1.05,2.25,1.81,3.23,1.05,1.35,2.11,2.71,3.16,4.06.95,1.22,1.94,2.47,3.33,3.13,1.25.59,2.68.63,4.06.67,3,.07,6.01.14,9.01.21,1.73.04,3.89-.21,4.46-1.84.34-.97-.08-2.01-.48-2.96-5.1-12.15-7.94-25.25-8.34-38.42-.05-1.82-.08-3.71-.86-5.36s-2.56-2.99-4.35-2.61c-2.55.53-3.28,3.77-2.79,4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.4,112.21c-.43,21.7-1.96,43.38-4.57,64.93-.42,3.51-.88,7.08-.24,10.55s2.54,6.91,5.71,8.47c2.09,1.03,4.5,1.15,6.83,1.25,6.91.3,13.82.6,20.74.89,5.07.22,10.44.37,14.89-2.07,4.27-2.34,7.05-6.8,8.42-11.47,1.37-4.67,1.5-9.6,1.61-14.47.35-14.76.71-29.52,1.06-44.28.14-6-.54-13.38-6.02-15.8-1.77-.78-3.76-.86-5.69-.93-10.47-.37-20.93-.75-31.4-1.12-2.66-.09-5.42-.17-7.84.95s-4.32,3.81-3.49,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.1,104.84c-5.65,33.25-6.8,67.26-3.43,100.81.13,1.3.33,2.72,1.31,3.58.92.81,2.26.87,3.48.9,4.01.08,8.02.15,12.03.23-.63-3.26-4.08-5.08-6-7.79-1.95-2.76-2.22-6.33-2.42-9.71-1.42-23.65-2.84-47.52.84-70.93.7-4.47,1.68-9.11,4.58-12.58,2.69-3.22,6.92-5.28,8.45-9.19-3.28.11-6.56.23-9.84.34-2.49.09-5.11.21-7.23,1.53s-3.43,4.27-1.78,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.7,140.78c-.51,5.49-.79,11.01-.83,16.52,0,.86.01,1.79.53,2.48.6.8,1.68,1.04,2.67,1.19,2.26.33,4.54.48,6.83.45.6,0,1.25-.04,1.74-.39.72-.5.9-1.46,1.02-2.33.67-5.12.97-10.3.89-15.47-.01-.84-.06-1.76-.61-2.4-.64-.75-1.74-.86-2.72-.93-2.05-.13-4.11-.27-6.16-.4-.92-.06-1.91-.11-2.71.35s-1.27,1.63-.63.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M287.83,119.33c-7.3,5.2-2.69,17.69-8.01,24.89-2.62,3.54-7.22,5.15-9.93,8.61-2.82,3.6-3.12,8.51-3.1,13.09.02,5.03.28,10.07.78,15.08.14,1.38.32,2.82,1.13,3.95,1.36,1.87,3.95,2.23,6.25,2.42,23.59,1.97,47.25,3.17,70.92,3.58,3.37.06,7.14-.05,9.51-2.45,2.23-2.25,2.44-5.74,2.52-8.91.43-16.71.86-33.41,1.29-50.12.06-2.42-.02-5.18-1.84-6.77-1.43-1.24-3.49-1.35-5.38-1.4-21.64-.57-43.28-.94-64.15-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.85,131.5c-1.41,16.06-1.84,32.21-1.27,48.32.02.7.07,1.45.49,2.01.54.73,1.53.92,2.43,1.03,1.72.22,3.45.36,5.19.43.65.02,1.37.01,1.87-.4.39-.33.57-.84.7-1.33.85-3.01,1.02-6.17,1.19-9.3.56-10.66,1.12-21.32,1.67-31.98.21-3.92.13-8.48-2.95-10.91-3.16-2.48-9.06-.77-9.31,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M347.35,135.76c-1.55.32-3.22,1.03-3.83,2.49-.73,1.73.64,3.94,2.51,4.17s3.69-1.46,3.72-3.34-1.6-3.49-2.39-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M345.87,151.08c-1.68.21-3.25,1.33-3.85,2.92s-.09,3.56,1.3,4.54c2.07,1.47,5.42-.08,5.85-2.59s-1.92-5.04-3.29-4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.95,169.04c-2.06.51-3.73,2.5-3.64,4.61s2.16,4.02,4.26,3.7c2.09-.32,3.5-2.7,3.09-4.77s-2.34-3.88-3.71-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M267.47,111.08c-1.63.81-3.33,1.69-4.29,3.24-.66,1.06-.89,2.32-1.08,3.55-1.26,8-1.58,16.14-.94,24.21.05.68.13,1.4.57,1.93.92,1.13,2.71.67,4.06.12,3.75-1.54,7.76-3.3,9.85-6.77,1.15-1.9,1.59-4.14,1.92-6.34.62-4.08.92-8.21.91-12.34,0-1.22-.04-2.47-.51-3.6-.78-1.86-2.66-3.08-4.61-3.59s-4.2-1.24-5.86-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.36,137.34c-.61,8.42-1.21,16.84-1.82,25.26-.08,1.17-.14,2.43.5,3.4.85,1.28,2.57,1.59,4.09,1.77,12.81,1.59,25.79,3.18,38.59,1.5.8-.11,1.68-.26,2.21-.88.45-.53.54-1.27.61-1.96.89-8.96,1.41-17.95,1.56-26.95.01-.61,0-1.29-.39-1.76-.44-.54-1.2-.65-1.89-.71-12.86-1.28-25.77-2.02-38.69-2.22-1.26-.02-2.59-.02-3.68.6s-1.83,2.08-1.1,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.86,143.75c-.66,4.35-1.02,8.75-1.07,13.15,0,.61.02,1.28.44,1.72.36.38.92.47,1.44.55,6.83.96,13.74,1.31,20.63,1.05.81-.03,1.73-.12,2.25-.74.32-.38.42-.89.51-1.37.73-4.02,1.05-8.11.97-12.19-.01-.62-.05-1.3-.45-1.77-.49-.59-1.35-.68-2.12-.72-6.52-.36-13.04-.72-19.56-1.08-.78-.04-1.6-.08-2.32.23s-1.3,1.1-.71,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.95,119.29c-1.31.07-2.42,1.09-2.97,2.28s-.64,2.54-.68,3.85c-.11,3.21-.01,6.42.29,9.61,1.99.04,3.81-1.3,4.89-2.97,1.08-1.68,1.56-3.66,2.02-5.6.41-1.74.81-3.62.13-5.27s-2.95-2.74-3.68-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M418.79,84.93c-3.53,1.99-3.98,6.81-4.01,10.86-.05,7.93-.11,15.86-.16,23.78-.01,1.76-.02,3.54.46,5.23,1.09,3.87,4.93,6.78,8.95,6.8,1.91,0,4.1-.88,4.55-2.74.56-2.36-1.92-4.2-3.26-6.23-1.55-2.35-1.62-5.34-1.63-8.15-.03-5.15-.06-10.3-.09-15.46-.01-2.36.03-4.89,1.39-6.81.8-1.13,1.98-1.93,2.89-2.97s1.54-2.55.95-3.8c-.49-1.04-1.67-1.56-2.79-1.79-2.95-.61-5.97.57-7.24,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M253.07,40.58c-2.63,1.8-3.02,5.46-3.16,8.64-.4,8.86-.79,17.72-1.19,26.57-.02.49-.02,1.04.34,1.38.28.27.71.31,1.1.33,6.45.44,12.89.89,19.34,1.33,4.63.32,9.35.63,13.86-.45,4.51-1.08,8.88-3.79,10.79-8.02,1.18-2.62,1.34-5.57,1.48-8.44.14-2.89.28-5.77.42-8.66.04-.74.07-1.49-.06-2.21-.2-1.08-.75-2.06-1.4-2.94-4.58-6.2-13.2-7.53-20.9-7.85-7.21-.3-14.43-.16-20.61.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.62,48.99c-1.33,6.87-1.88,13.9-1.65,20.89.02.58.07,1.21.47,1.63.33.35.84.47,1.32.55,1.29.23,2.6.37,3.91.41.75.02,1.55,0,2.18-.41.91-.59,1.18-1.79,1.38-2.86,1.08-5.98,2.17-12.05,1.59-18.1-.08-.83-.24-1.75-.9-2.25-.54-.41-1.27-.44-1.95-.45-1.99-.03-3.97-.07-5.96-.1-.21.44-.42.89-.38.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M244.64,55.13c-1.98.41-3.83,1.85-4.32,3.81s.73,4.31,2.71,4.71c2.1.42,4.19-1.51,4.36-3.64s-1.25-4.17-2.75-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.15,46.56c-10.61-1.53-21.37-2-32.07-1.39-.48.03-.98.06-1.38.33-.52.34-.74.98-.92,1.57-1.83,6.18-1.71,12.75-1.58,19.19.03,1.56.19,3.37,1.48,4.25.73.5,1.67.57,2.56.62,9.36.55,18.73,1.05,28.1,1.5.4.02.82.03,1.16-.17.56-.33.68-1.07.74-1.72.67-7.26,1.34-14.51,2.01-21.77.08-.85.11-1.82-.1-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.03,51.02c11.77.5,23.54,1.26,35.28,2.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.92,57.51c11.78.37,23.55.9,35.31,1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.25,64.17c11.07.97,22.14,1.94,33.21,2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M212.42,45.02c-1.52,8.75-1.85,17.7-.99,26.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M219.46,45.16c-.62,8.92-1.43,17.82-2.41,26.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.14,42.55c-3.6-.13-7.21-.26-10.81-.39-.3-.01-.61-.02-.88.11-.6.28-.72,1.07-.77,1.73-.64,9.39-1.27,18.77-1.91,28.16-.06.92-.11,1.91.39,2.68.69,1.09,2.14,1.33,3.42,1.48,1.9.22,3.81.43,5.71.65.49.06,1,.11,1.47-.02,1.53-.42,1.95-2.36,2.1-3.94.73-8.24,1.46-16.48,2.2-24.72.17-1.88.3-3.91-.93-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.38,45.03c-1.69,8.87-2.55,17.89-2.56,26.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M232.01,45.59c-.96,8.81-1.55,17.66-1.77,26.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.3,56.6c-1.16-1.17-3.3-.92-4.42.29s-1.31,3.08-.81,4.65c.67,2.13,3.13,3.93,5.11,2.89.96-.5,1.52-1.53,1.86-2.56.39-1.2.53-2.54.05-3.7s-1.69-2.09-1.79-1.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAni20);
export default __webpack_public_path__ + "static/media/camera_ani_20.ed51f9776113b0a4902d007fabbf56ee.svg";
export { ForwardRef as ReactComponent };